import Vue from 'vue'
import VueRouter from 'vue-router'

import {
  ROUTE_CALENDAR,
  ROUTE_AUTH,
  ROUTE_SETTINGS,
  ROUTE_ATTENDANCE_NEW,
  ROUTE_ATTENDANCE_ITEM,
  ROUTE_PREVIEW,
  ROUTE_PREVIEW_DETAILS,
  ROUTE_PREVIEW_CURRENT,
  ROUTE_AUTH_PASSWORD_DEFINE
} from './constants'

const AppLayout = () => import(/* webpackChunkName: "views/Layout" */ '@/views/Layout')
const AppAuth = () => import(/* webpackChunkName: "views/AppAuth" */ '@/views/AppAuth')
const AppSettings = () => import(/* webpackChunkName: "views/AppSettings" */ '@/views/AppSettings')
const AppCalendarLayout = () => import(/* webpackChunkName: "views/AppCalendarLayout" */ '@/views/AppCalendarLayout')
const AppAttendanceNew = () => import(/* webpackChunkName: "views/AppAttendanceNew" */ '@/views/AppAttendanceNew')
const AppAttendanceItem = () => import(/* webpackChunkName: "views/AppAttendanceItem" */ '@/views/AppAttendanceItem')
const AppAttendanceLayout = () => import(/* webpackChunkName: "views/AppAttendanceLayout" */ '@/views/AppAttendanceLayout')
const AppAttendanceOffer = () => import(/* webpackChunkName: "components/AttendanceOffer" */ '@/components/AttendanceOffer')
const AppPreview = () => import(/* webpackChunkName: "components/AttendanceOffer" */ '@/views/AppPreview')
const AppPreviewCurrent = () => import(/* webpackChunkName: "components/AppPreviewCurrent" */ '@/views/AppPreviewCurrent')
const AppPreviewDetails = () => import(/* webpackChunkName: "components/AppPreviewDetails" */ '@/views/AppPreviewDetails')
const AppAuthDefinePassword = () => import(/* webpackChunkName: "views/views/auth/AuthDefinePassword" */ '@/views/auth/AuthDefinePassword')

Vue.use(VueRouter)

const routes = [{
  path: '/',
  component: AppLayout,
  children: [{
    path: '',
    name: ROUTE_AUTH,
    component: AppAuth
  }, {
    path: 'definePassword',
    name: ROUTE_AUTH_PASSWORD_DEFINE,
    component: AppAuthDefinePassword
  },
  {
    path: 'settings',
    name: ROUTE_SETTINGS,
    component: AppSettings
  },
  {
    path: 'attendances/calendar',
    name: ROUTE_CALENDAR,
    component: AppCalendarLayout,
    props: true
  }, {
    path: 'attendances',
    component: AppAttendanceLayout,
    children: [{
      path: 'attendances',
      name: ROUTE_ATTENDANCE_NEW,
      component: AppAttendanceNew,
      props: true
    }, {
      path: 'attendances/:attendanceId',
      name: ROUTE_ATTENDANCE_ITEM,
      component: AppAttendanceItem,
      props: true
    }, {
      path: 'preview',
      name: ROUTE_PREVIEW,
      component: AppPreview,
      children: [{
        path: ':queueId/details',
        name: ROUTE_PREVIEW_DETAILS,
        component: AppPreviewDetails,
        props: true
      }, {
        path: ':queueId/current/:attendanceId',
        name: ROUTE_PREVIEW_CURRENT,
        component: AppPreviewCurrent,
        props: true
      }]

    }]

  }]
}, {
  path: '/attendanceOffer/:attendanceId',
  component: AppAttendanceOffer
}]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

document.router = router

export default router
